import { render, staticRenderFns } from "./ApplicationDistanceEducationView.vue?vue&type=template&id=1d2fe222&scoped=true&"
import script from "./ApplicationDistanceEducationView.vue?vue&type=script&lang=js&"
export * from "./ApplicationDistanceEducationView.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationDistanceEducationView.vue?vue&type=style&index=0&id=1d2fe222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2fe222",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VDataTable})
